export const state = () => ({
  mainType: 0, // 主分类
  orderId: 0, // 订单id
  orderInfo: null, // 订单详情信息
  dateList: [] // 订阅日期列表
})

export const getters = {
  getterValue: (state) => {
    return state.mainType
  }
}

export const mutations = {
  updateMainType: (state, payload) => {
    state.mainType = payload
  },
  updateOrderId: (state, payload) => {
    state.orderId = payload
  },
  updateOrderInfo: (state, payload) => {
    state.orderInfo = payload
  },
  updateDateList: (state, payload) => {
    state.dateList = payload
  },
  updateDateListVerify: (state, { saledate, stockcount }) => {
    state.dateList.forEach((date) => {
      if (date.date === saledate) {
        date.verify = true
        date.stockNum = stockcount
      }
    })
  }
}

export const actions = {
  updateActionMainType({ commit }, payload) {
    commit('updateMainType', payload)
  },
  updateActionOrderId({ commit }, payload) {
    commit('updateOrderId', payload)
  },
  updateActionOrderInfo({ commit }, payload) {
    commit('updateOrderInfo', payload)
  },
  // 更新订阅商品 日期和数量 列表
  updateActionDateList({ commit }, payload) {
    commit('updateDateList', payload)
  },
  // 更新订阅商品 日期和数量 列表
  updateActionDateListVerify({ commit }, stockNoEnough) {
    commit('updateDateList', stockNoEnough)
  }
}

export const namespaced = true
